import React from 'react'
import styled from '@emotion/styled'
import { Bold } from 'components/Text'

const VendorName = styled(Bold)`
  margin: auto;
  text-transform: capitalize;
`

const VendorLogo = styled.img`
  margin: auto;
`

const Vendor = ({ name }) => (
  <React.Fragment>
    <VendorLogo
      width="150px"
      src={process.env.PUBLIC_URL + `/${name.toLowerCase()}.png`}
      onError={e => (e.target.style.display = 'none')}
    />
    <VendorName>{name}</VendorName>
  </React.Fragment>
)

export default Vendor



// WEBPACK FOOTER //
// ./src/components/Vendor.js